// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__28W_A","footer":"ChangeClinic_footer__wR-MK"};